<template>
    <v-row v-if="summary">
        <!-- FIRST ROW -->
        <v-col cols="4">
            <div class="label">
                {{ $tc('exercises.exercises', 2) }}
            </div>
            <div class="value">
                {{ summary.exercises }}
            </div>
        </v-col>
        <v-col cols="4">
            <div class="label">
                {{ $tc('exercises.sets', 2) }}
            </div>
            <div class="value">
                {{ summary.sets }}
            </div>
        </v-col>
        <v-col cols="4">
            <div class="label">
                {{ $t('exercises.reps') }}
            </div>
            <div class="value">
                {{ summary.reps }}
            </div>
        </v-col>
        <!-- SECOND ROW -->
        <v-col cols="6">
            <div class="label">
                {{ $t('exercises.intensity') }}
            </div>
            <div class="value">
                {{ summary.intensity }}%
            </div>
        </v-col>
        <v-col cols="6">
            <div class="label">
                {{ $t('exercises.volume_weight') }}
            </div>
            <div class="value">
                {{ summary.weight }}
            </div>
        </v-col>
        <!-- THIRD ROW -->
        <v-col cols="6" class="text-center">
            <v-icon large color="#203c6d">mdi-battery-high</v-icon>
            <div class="label">
                {{ $t('common.wellness') }}
                <br>
                {{ summary.wellness }}/5
            </div>
        </v-col>
        <v-col cols="6" class="text-center">
            <v-icon large color="#203c6d">mdi-av-timer</v-icon>
            <div class="label">
                {{ $tc('common.minutes', 2) }}
                <br>
                {{ summary.duration }}
            </div>
        </v-col>
        <v-col cols="6" class="text-center">
            <v-icon large color="#203c6d">mdi-fire</v-icon>
            <div class="label">
                {{ $t('exercises.intensity') }}
                <br>
                {{ summary.effort }}/10
            </div>
        </v-col>
        <v-col cols="6" class="text-center">
            <v-icon large color="#203c6d">mdi-battery-high</v-icon>
            <div class="label">
                {{ $t('common.charge') }}
                <br>
                {{ summary.charge }}
            </div>
        </v-col>
        <!-- DIVIDER -->
        <v-col cols="12" class="py-0">
            <v-divider class="divider-color"></v-divider>
        </v-col>
        <!-- COMMENT -->
        <v-col cols="12" v-if="summary.comment">
            <b>{{ $t('common.comment') }}:</b>
            {{ summary.comment }}
        </v-col>
        <!-- BACK TO ROUTINE -->
        <v-col cols="12">
            <v-btn
                class="black--text normal-btn" block
                color="primary"
                depressed large
                @click="emitClick"
            >
                {{ $t('routines.back_to_routines') }}
            </v-btn>
        </v-col>
        <v-col cols="12" class="logo-title">
            {{ appName }}
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "SummaryData",
    props: {
        summary: {
            type: Object,
            default: null
        }
    },
    methods: {
        emitClick() {
            const vm = this
            vm.$emit('back')
        },
    }
}
</script>

<style scoped>

.value {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: var(--v-secondary-base);
    text-align: center;
}

.label {
    font-weight: bold;
    color: #333333;
    font-size: 13px;
    line-height: 18px;
    text-transform: uppercase;
    text-align: center;
}

.divider-color {
    height: 1px;
    background-color: var(--v-secondary-base);
}

.logo-title {
    font-weight: bold;
    font-size: 20px;
    color: var(--v-accent-base);
    text-align: center;
}

</style>